<template>
  <div class="content_main">
    <div class="bgOne">
      <div class="centerOne">
        <div class="head">
          <div class="firm_logo">
            <img src="../../assets/img/logo1.svg" alt="" />
          </div>
          <div class="firm_title">
            <div class="title_one">The ALL-IN-ONE Dropshipping</div>
            <div class="title_two">Super Housekeeper</div>
          </div>
          <div class="firm_video">
            <!-- <img src="../../assets/img/shiping1.svg" alt="" style="width:100%;height:100%"> -->
            <video
              width="100%"
              height="100%"
              muted="muted"
              controls
              autoplay="autoplay"
              loop="loop"
              poster="../../assets/img/shiping1.svg"
            >
              <source src="../../assets/video/video.mp4" type="video/mp4" />
              -->
              <!-- <source src="movie.ogg" type="video/ogg">
                            <source src="movie.webm" type="video/webm"> -->
              <!-- 您的浏览器不支持 video 标签。 -->
            </video>
          </div>
        </div>
      </div>
    </div>
    <div class="bgTwo">
      <div class="centerTwo">
        <div class="subtitleOne">
          <div class="contentOne">
            <span>Save your money</span>
            <span
              >We will source for you with lower price and high quality.</span
            >
          </div>
          <div class="contentOne_imgOne">
            <img src="../../assets/img/1-03.svg" alt="" />
          </div>
        </div>
        <div class="subtitleTwo">
          <div class="contentTwo">
            <span>Protect your store</span>
            <span
              >We are your stable partner ，help you to control risks and avoid
              buyers disputes.</span
            >
          </div>
          <div class="contentTwo_imgTwo">
            <img src="../../assets/img/1_huaban1.svg" alt="" />
          </div>
        </div>
        <div class="subtitleOne subtitleThree">
          <div class="contentOne contentThree">
            <span>Grow your money</span>
            <span
              >We are your trust friend ，share you the good secrets and tips to
              grow your order sales.</span
            >
          </div>
          <div class="contentOne_imgOne contentThree_imgThree">
            <img src="../../assets/img/1-02.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="bgThree">
      <div class="centerThree">
        <div class="abdomen">
          <div class="chest">
            <div class="chestTop">
              <span> Plentiful, </span>
              <span> All-In-One Services </span>
            </div>
          </div>
          <div class="abdomen_one">
            <div class="abdomen_content1">
              <div class="abdomen_img1">
                <img src="../../assets/img/1-04.svg" alt="" />
              </div>
              <div class="abdomen_wenzi1">We Source For You</div>
            </div>
            <div class="abdomen_content1 abdomen_content2">
              <div class="abdomen_img1">
                <img src="../../assets/img/1-06.svg" alt="" />
              </div>
              <div class="abdomen_wenzi1">We Purchase For you</div>
            </div>
            <div class="abdomen_content1">
              <div class="abdomen_img1">
                <img src="../../assets/img/1-05.svg" alt="" />
              </div>
              <div class="abdomen_wenzi1">We Fulfill For You</div>
            </div>
            <div class="abdomen_content1 abdomen_content2">
              <div class="abdomen_img1">
                <img src="../../assets/img/1-07.svg" alt="" />
              </div>
              <div class="abdomen_wenzi1">We Stock For You</div>
            </div>
            <div class="abdomen_content1">
              <div class="abdomen_img1">
                <img src="../../assets/img/1-08.svg" alt="" />
              </div>
              <div class="abdomen_wenzi1">We Quality Check For You</div>
            </div>
            <div class="abdomen_content1 abdomen_content2">
              <div class="abdomen_img1">
                <img src="../../assets/img/1-09.svg" alt="" />
              </div>
              <div class="abdomen_wenzi1">We Ship For You</div>
            </div>
            <div class="abdomen_content1">
              <div class="abdomen_img1">
                <img src="../../assets/img/1-11.svg" alt="" />
              </div>
              <div class="abdomen_wenzi1">We Optimize Shipping For You</div>
            </div>
            <div class="abdomen_content1 abdomen_content2">
              <div class="abdomen_img1">
                <img src="../../assets/img/1-10.svg" alt="" />
              </div>
              <div class="abdomen_wenzi1">
                We Offer 24/7 service VIP customer manager
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgFour">
      <div class="centerFour">
        <div class="thigh">
          <div class="thigh_title1">
            <span> Features Services</span>
            <span>Print On Demand</span>
          </div>
          <div class="thigh_content">
            <div class="thigh_img">
              <img src="../../assets/img/2-1.png" alt="" />
            </div>
            <!-- 轮播图 -->
            <el-carousel indicator-position="none" height="30rem" arrow="never">
              <el-carousel-item v-for="item in customize" :key="item.id">
                <div class="thigh_bottom">
                  <div class="thigh_title iconfont" v-html="item.icon">
                    <!-- {{item.icon}}  -->
                  </div>
                  <div class="thigh_bottom_content">
                    <span>{{ item.name }}</span>
                    <!-- <span>Card and Stickers</span> -->
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div class="bgFive">
      <div class="centerFive">
        <div class="calf">
          <div class="calf_top">
            <div class="calf_title">Why need POD Services?</div>
            <div class="calf_content">
              <span>Compared with General Product , More </span>
              <span>Sales！More Profit!</span>
            </div>
          </div>
          <!-- 轮播图 -->
          <el-carousel
            indicator-position="outside"
            height="150rem"
            arrow="always"
          >
            <el-carousel-item v-for="item in imgList1" :key="item.id">
              <div class="calf_bottom">
                <div class="calf_img_bg">
                  <div class="calf_img">
                    <img :src="item.img" alt="" />
                  </div>
                </div>
                <div class="product_name">{{ item.name }}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="bgSix">
      <div class="centerSix">
        <div class="anklk">
          <div class="ankle_title">Why Choose Us?</div>
          <!-- 轮播图 -->
          <el-carousel
            indicator-position="outside"
            height="177rem"
            arrow="never"
          >
            <el-carousel-item v-for="item in specialty" :key="item.id">
              <div class="anklk_img_bg">
                <div class="anklk_img">
                  <img :src="item.img" alt="" />
                </div>
                <div class="anklk_middle">
                  <div class="anklk_icon iconfont" v-html="item.icon">
                    <!-- <img src="" alt=""> -->
                    <!-- &#xe607; -->
                  </div>
                  <div class="anklk_pod">
                    <span>{{ item.anklk_pod1 }}</span>
                    <span> {{ item.anklk_pod2 }}</span>
                  </div>
                </div>
                <div class="pod_option">
                  <div class="option_one">
                    <div class="pod_icon">☑</div>
                    <div class="pod_content">
                      {{ item.pod_content1 }}
                    </div>
                  </div>
                  <div class="option_one">
                    <div class="pod_icon">☑</div>
                    <div class="pod_content">
                      {{ item.pod_content2 }}
                    </div>
                  </div>
                  <div class="option_one">
                    <div class="pod_icon">☑</div>
                    <div class="pod_content">
                      {{ item.pod_content3 }}
                    </div>
                  </div>
                  <div class="option_one">
                    <div class="pod_icon">{{ item.check1 }}</div>
                    <div class="pod_content">
                      {{ item.pod_content4 }}
                    </div>
                  </div>
                  <div class="option_one">
                    <div class="pod_icon">{{ item.check2 }}</div>
                    <div class="pod_content">
                      {{ item.pod_content5 }}
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="bgSeven">
      <div class="centerSeven">
        <div class="workflow">
          <div class="workflow_top">
            <div class="workflow_title">Why need POD Services?</div>
            <div class="workflow_center">
              <span>Compared with General Product , More</span>
              <span> Sales! More Profit!</span>
            </div>
          </div>
          <div class="workflow_bottom">
            <div class="workflow_one">
              <div class="workflow_icon">
                <img src="../../assets/img/2-18.png" alt="" />
              </div>
              <div class="workflow_cont">Contact Us</div>
              <div class="workflow_point">
                <img src="../../assets/img/mb-1-2.svg" alt="" />
              </div>
            </div>
            <div class="workflow_two">
              <div class="workflow_icon2">
                <img src="../../assets/img/2-15.png" alt="" />
              </div>
              <div class="workflow_cont2">
                Pay Us
                <div class="workflow_point2">
                  <img src="../../assets/img/mb-1-1.svg" alt="" />
                </div>
              </div>
            </div>
            <div class="workflow_three">
              <div class="workflow_icon3">
                <img src="../../assets/img/2-33.svg" alt="" />
              </div>
              <div class="workflow_cont3">We ship to your customer</div>
            </div>
          </div>
          <div class="mb-abous">
            <div class="bgtwo_title">About US</div>
            <div class="abous_us">
              <p>
                We are the best All-In-One dropshipping agent. We not only can
                supply massive high-quality products, but also help you POD in 1
                pcs, to helping you own your own supply chain and competitive
                product price.
              </p>
              <div class="top-line">
                <div class="line"></div>
                <p class="abous_title">Our Mission</p>
              </div>
              <p>
                Our mission is to enable any seller, regardless of size, to ship
                their orders with fast and cost-effective fulfillment.
              </p>
              <div class="top-line">
                <div class="line"></div>
                <p class="abous_title">Our Team</p>
              </div>
              <p>
                Our team has decades of drop shipping experience, can 100% auto
                fulfill more than100,000 orders, we invest 200% passion to
                accomplish everything.
              </p>
              <div class="top-line">
                <div class="line"></div>
                <p class="abous_title">Our address</p>
              </div>
             <p style="color:black;">SUORONG LIMITED</p>
           <p>
           12/F, Sandai
            Building, 137-139 Connaught Road Central, Hong Kong
          </p>
          <p style="margin-top:2rem;color:black">Shenzhen Sichuang E-commerce Co., Ltd.</p>
         
          <p>
            Room405, Buiding A, Yongchang industrial area, Lixin
Road NO.16, Nanwan Street, Longgang District, Shenzhen City, Guangdong Province, China
          </p>
            </div>
          </div>
          <div @click="centerDialogVisible = true" class="join_us">
            <div class="join_title">
              <img src="../../assets/img/mb-1-3.svg" alt="" />
            </div>
            <div class="join_content">Join us now</div>
          </div>
          <!-- 点击事件弹窗 邮箱链接-->
          <el-dialog
            title="Contact US"
            :visible.sync="centerDialogVisible"
            width="60%"
            center
          >
            <a
              href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=support@webfba.com"
              style="float: left"
              ><div
                style="
                  float: left;
                  display: inline;
                  font-size: 8rem;
                  line-height: 8rem;
                "
              >
                click:
              </div>
              <img
                src="../../assets/img/logo_gmail.png"
                alt=""
                style="width: 20rem; height: 8rem; float: right"
            /></a>
            <span slot="footer" class="dialog-footer">
              <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
              <!-- <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button> -->
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
    <!-- 返回顶部 -->
    <el-backtop class="backtop" :right="35"></el-backtop>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      // 弹窗事件
      centerDialogVisible: false,
      imgList1: [
        {
          id: 0,
          img: require("../../assets/img/2-2.png"),
          name: "Phone Case",
        },
        {
          id: 1,
          img: require("../../assets/img/2-3.png"),
          name: "Wall Decoration",
        },
        {
          id: 2,
          img: require("../../assets/img/2-4.png"),
          name: "Ball",
        },
        {
          id: 3,
          img: require("../../assets/img/2-5.png"),
          name: "Clothing",
        },
        {
          id: 4,
          img: require("../../assets/img/2-6.png"),
          name: "Accessories",
        },
        {
          id: 5,
          img: require("../../assets/img/2-7.png"),
          name: "Wooden product",
        },
        {
          id: 6,
          img: require("../../assets/img/2-8.png"),
          name: "Household items",
        },
        {
          id: 7,
          img: require("../../assets/img/2-9.png"),
          name: "3D Printing",
        },
      ],
      customize: [
        {
          id: 0,
          icon: "&#xe60c;",
          name: "Print On Demand",
        },
        {
          id: 1,
          icon: "&#xe610;",
          name: "1 to 1 DIY Customization",
        },
        {
          id: 2,
          icon: "&#xe60f;",
          name: "Personalized Customization",
        },
        {
          id: 3,
          icon: "&#xe60d;",
          name: "Engraved brand Logo On Product",
        },
        {
          id: 4,
          icon: "&#xe60e;",
          name: "Custom Packaging, Card and Stickers",
        },
      ],
      specialty: [
        {
          id: 0,
          icon: "&#xe607;",
          anklk_pod1: "Advanced POD",
          anklk_pod2: "Equipment",
          pod_content1: "The most advanced POD equipment in the world",
          pod_content2: "The same equipment as the Nike factory",
          pod_content3: "Meet all your customization requirements",
          img: require("../../assets/img/2-36.jpg"),
        },
        {
          id: 1,
          icon: "&#xe604;",
          anklk_pod1: "Competitive",
          anklk_pod2: "Product Price",
          pod_content1: "No Setup Fee",
          pod_content2: "No Monthly Fee",
          pod_content3: "No Hidden Fee",
          pod_content4: "So cheaper than AliExpress",
          img: require("../../assets/img/2-38.svg"),
          check1: "☑",
        },
        {
          id: 2,
          icon: "&#xe608;",
          anklk_pod1: '"0" Inventory Risk',
          // anklk_pod2:"Equipment",
          pod_content1: "No Minimum Order",
          pod_content2: "$0 warehouse storage fee",
          pod_content3: "Open an online shop at zero cost",
          pod_content4: "Free your financial pressure & reduce inventory risk",
          img: require("../../assets/img/2-39.svg"),
          check1: "☑",
        },
        {
          id: 3,
          icon: "&#xe609;",
          anklk_pod1: "Fast Processing",
          anklk_pod2: "& Shipping",
          pod_content1: "Quickly response 24/7",
          pod_content2: "Delivery 7 days or less",
          pod_content3: "100% Auto-Process Orders",
          pod_content4: "Overseas warehouse service",
          pod_content5: "Full track and feedback after delivery",
          img: require("../../assets/img/2-40.svg"),
          check1: "☑",
          check2: "☑",
        },
        {
          id: 4,
          icon: "&#xe60b;",
          anklk_pod1: "Worry-free",
          anklk_pod2: "after-sales",
          pod_content1: "Professional experienced team",
          pod_content2: "Convenient Return & Refund",
          pod_content3: "Fast handling of after-sales problems",
          pod_content4: "Provide delivery proof for PayPal disputes",
          img: require("../../assets/img/2-42.svg"),
          check1: "☑",
        },
      ],
    };
  },
};
</script>
<style lang="stylus" scoped>
html {
  font-size: 62.5%;
  width: 100%;
  min-width: 127rem;

  @font-face {
    font-family: 'iconfont';
    src: url('../../assets/iconfont/iconfont.eot');
    src: url('../../assets/iconfont/iconfont.eot?#iefix') format('embedded-opentype'), url('../../assets/iconfont/iconfont.woff2') format('woff2'), url('../../assets/iconfont/iconfont.woff') format('woff'), url('../../assets/iconfont/iconfont.ttf') format('truetype'), url('../../assets/iconfont/iconfont.svg#iconfont') format('svg');
  }

  .iconfont {
    font-family: 'iconfont' !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .content_main {
    float: left;
    background-color: #F6F7F8;
    width: 100%;
    padding-top: 20rem;

    .bgOne {
      .centerOne {
        .head {
          .firm_logo {
            margin: 0 auto;
            width: 60rem;
            height: 33rem;

            img {
              width: 100%;
            }
          }

          .firm_title {
            width: 100%;
            height: 39rem;

            .title_one {
              color: #333333;
              font-size: 10rem;
              font-weight: 900;
              font-family: Arial-Black, Arial;
              line-height: 10rem;
              text-align: center;
            }

            .title_two {
              color: #FF7300;
              margin-top: 2rem;
              font-size: 10rem;
              font-weight: 900;
              font-family: Arial-Black, Arial;
              line-height: 10rem;
              text-align: center;
            }
          }

          .firm_video {
            width: 95%;
            height: 70.5rem;
            margin: 0 auto;
          }
        }
      }
    }

    .bgTwo {
      margin-top: 10rem;

      .centerTwo {
        .subtitleOne {
          background-color: #FFFFFF;
          width: 90%;
          margin: 0 auto;
          height: 35rem;
          box-shadow: 0px 0px 10px 0px #E1E1E1;
          border-radius: 2rem;
          padding-top: 5rem;
          box-sizing: border-box;
          margin-bottom: 7rem;

          .contentOne {
            width: 65%;
            height: 100%;
            float: right;

            span:nth-child(1) {
              font-size: 7rem;
              color: #333333;
              font-family: Arial-BoldMT, Arial;
              font-weight: 900;
              line-height: 10rem;
              display: block;
            }

            span:nth-child(2) {
              margin-top: 3rem;
              font-size: 5rem;
              font-family: ArialMT;
              color: #666666;
              line-height: 6rem;
              display: block;
            }
          }

          .contentOne_imgOne {
            width: 20rem;
            height: 20rem;
            margin-left: 10rem;

            img {
              width: 100%;
            }
          }
        }

        .subtitleTwo {
          background-color: #FFFFFF;
          width: 90%;
          margin: 0 auto;
          height: 40rem;
          box-shadow: 0px 0px 10px 0px #E1E1E1;
          border-radius: 2rem;
          padding-top: 5rem;
          box-sizing: border-box;
          margin-bottom: 7rem;

          .contentTwo {
            width: 65%;
            height: 100%;
            float: left;
            margin-left: 8rem;

            span:nth-child(1) {
              font-size: 7rem;
              color: #333333;
              font-family: Arial-BoldMT, Arial;
              font-weight: 900;
              line-height: 10rem;
              display: block;
            }

            span:nth-child(2) {
              margin-top: 3rem;
              font-size: 5rem;
              font-family: ArialMT;
              color: #666666;
              line-height: 6rem;
              display: block;
            }
          }

          .contentTwo_imgTwo {
            width: 20rem;
            height: 20rem;
            float: right;
            margin-right: 10rem;
          }
        }

        .subtitleThree {
          width: 90%;
          height: 45rem;

          .contentThree {
            margin-right: 5rem;
          }
        }
      }
    }

    .bgThree {
      .centerThree {
        width: 100%;
        padding: 2rem;
        box-sizing: border-box;

        .chest {
          .chestTop {
            span {
              text-align: center;
              font-size: 8rem;
              font-weight: 900;
              display: block;
              font-family: Arial-Black, Arial;
            }
          }
        }

        .abdomen_one {
          width: 100%;
          margin-top: 7rem;

          .abdomen_content1 {
            margin-bottom: 2.5rem;
            float: left;
            width: 49%;
            height: 35rem;
            background-color: #FFFFFF;
            border-radius: 2rem;

            .abdomen_img1 {
              margin: 0 auto;
              width: 15rem;
              height: 15rem;
              margin-top: 5rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .abdomen_wenzi1 {
              font-size: 4rem;
              text-align: center;
              margin-top: 4rem;
              font-weight: bold;
            }
          }

          .abdomen_content2 {
            float: right;
          }
        }
      }
    }

    .bgFour {
      float: left;
      width: 100%;
      margin-top: 10rem;
      padding-bottom: 10rem;

      .centerFour {
        .thigh {
          width: 100%;

          .thigh_title1 {
            width: 100%;
            font-size: 7rem;
            font-family: Arial-Black, Arial;
            font-weight: 900;
            color: #333333;

            span {
              display: block;
              text-align: center;
            }
          }

          .thigh_content {
            margin-top: 10rem;
            width: 80%;
            margin: 0 auto;

            .thigh_img {
              width: 100rem;
              height: 100rem;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .thigh_bottom {
              .thigh_title {
                width: 20rem;
                height: 20rem;
                border-radius: 10rem;
                float: left;
                background-color: #FF723F;
                color: #FFF;
                font-size: 15rem;
                text-align: center;
                box-sizing: border-box;
                padding-top: 2rem;
              }

              .thigh_bottom_content {
                width: 79rem;
                margin-left: 5rem;
                margin-top: 5rem;
                float: left;
                font-size: 6rem;
                font-family: Arial-Black, Arial;
                font-weight: 900;
                color: #333333;
                line-height: 10rem;

                span {
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    .bgFive {
      width: 100%;
      background-color: #333333;
      padding-bottom: 20rem;
      float: left;

      .centerFive {
        width: 100%;
        float: left;
        margin-top: 10rem;

        .calf {
          .calf_top {
            .calf_title {
              font-size: 7rem;
              font-family: Arial-Black, Arial;
              font-weight: 900;
              color: #FFFFFF;
              line-height: 10remq;
              text-align: center;
            }

            .calf_content {
              font-size: 4.5rem;
              margin-top: 5rem;
              font-family: ArialMT;
              color: #FFFFFF;
              line-height: 5rem;
              text-align: center;

              span {
                display: block;
              }
            }
          }

          .calf_bottom {
            margin-top: 5rem;
            display: block;
            margin-bottom: 5rem;

            .calf_img_bg {
              margin-top: 10rem;
              width: 80%;
              height: 120rem;
              background-color: #FFFFFF;
              margin: auto;
              border-radius: 5rem;
              padding-top: 10rem;

              .calf_img {
                width: 95%;
                height: 100rem;
                margin: auto;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            .product_name {
              margin-top: 10rem;
              padding-top: 5rem;
              font-size: 8rem;
              font-family: Arial-Black, Arial;
              font-weight: 900;
              color: #FFFFFF;
              width: 70%;
              height: 20rem;
              margin: 0 auto;
              border-bottom: #FF7300 solid 0.5rem;
            }
          }
        }
      }
    }

    .bgSix {
      float: left;
      width: 100%;

      .centerSix {
        .anklk {
          .ankle_title {
            margin-top: 10rem;
            margin-bottom: 10rem;
            font-size: 8rem;
            font-family: Arial-Black, Arial;
            font-weight: 900;
            color: #333333;
            text-align: center;
          }

          .anklk_img_bg {
            width: 95%;
            height: 177rem;
            background-color: #FFFFFF;
            margin: 0 auto;
            padding-top: 10rem;
            border-radius: 5rem;
            padding-bottom: 10rem;

            .anklk_img {
              width: 100%;
              height: 50rem;
              text-align: center;

              img {
                width: 80%;
                height: 100%;
              }
            }

            .anklk_middle {
              width: 90%;
              height: 26rem;
              margin: 0 auto;
              margin-top: 15rem;

              .anklk_icon {
                width: 15rem;
                height: 15rem;
                float: left;
                font-size: 15rem;
                color: #FF7300;
              }

              .anklk_pod {
                width: 70rem;
                font-family: Arial-BoldMT, Arial;
                font-weight: bold;
                color: #333333;
                font-size: 8rem;
                margin-left: 5rem;
                float: left;
              }
            }

            .pod_option {
              width: 90%;
              margin: 0 auto;

              .option_one {
                margin-bottom: 5rem;

                .pod_icon {
                  width: 5rem;
                  height: 5rem;
                  display: inline-block;
                  float: left;
                  margin-left: 12rem;
                  font-size: 5rem;
                  color: #F98E20;
                  // margin-top: -3rem;
                }

                .pod_content {
                  font-size: 5rem;
                  font-family: ArialMT;
                  color: #666666;
                  width: 87rem;
                  display: inline-block;
                  margin-left: 3rem;
                }
              }
            }
          }
        }
      }
    }

    .bgSeven {
      width: 100%;
      float: left;
      margin-top: 10rem;

      .centerSeven {
        .workflow {
          .workflow_top {
            .workflow_title {
              width: 100%;
              text-align: center;
              font-size: 8rem;
              font-family: Arial-Black, Arial;
              font-weight: 900;
              color: #333333;
            }

            .workflow_center {
              padding-top: 5rem;
              margin: 0 auto;
              width: 80%;
              text-align: center;
              font-size: 5rem;
              color: #666666;
              font-family: LucidaGrande;
            }
          }

          .workflow_bottom {
            position: relative;

            .workflow_one {
              border-radius: 2rem;
              width: 80%;
              height: 30rem;
              margin: 0 auto;
              background-color: #FFFFFF;
              margin-top: 10rem;

              .workflow_icon {
                width: 20rem;
                height: 20rem;
                float: left;
                margin-top: 6rem;
                margin-left: 13rem;

                img {
                  width: 100%;
                  height: 90%;
                }
              }

              .workflow_cont {
                font-size: 9rem;
                font-family: Arial-BoldMT, Arial;
                font-weight: bold;
                color: #333333;
                width: 60rem;
                height: 22rem;
                float: left;
                text-align: center;
                margin-top: 10rem;
              }

              .workflow_point {
                width: 20rem;
                height: 50rem;
                position: absolute;
                left: 99rem;
                top: 9rem;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            .workflow_two {
              border-radius: 2rem;
              width: 80%;
              height: 30rem;
              margin: 0 auto;
              background-color: #FFFFFF;
              margin-top: 20rem;

              .workflow_icon2 {
                width: 20rem;
                height: 20rem;
                float: right;
                margin-top: 6rem;
                margin-right: 13rem;

                img {
                  width: 100%;
                  height: 90%;
                }
              }

              .workflow_cont2 {
                font-size: 9rem;
                font-family: Arial-BoldMT, Arial;
                font-weight: bold;
                color: #333333;
                width: 60rem;
                height: 22rem;
                float: right;
                text-align: center;
                margin-top: 10rem;
              }

              .workflow_point2 {
                width: 20rem;
                height: 50rem;
                position: absolute;
                left: 7rem;
                top: 61rem;
              }
            }

            .workflow_three {
              border-radius: 2rem;
              width: 80%;
              height: 30rem;
              margin: 0 auto;
              background-color: #FFFFFF;
              margin-top: 20rem;

              .workflow_icon3 {
                width: 20rem;
                height: 20rem;
                // background-color: #FF7300;
                float: left;
                margin-top: 6rem;
                margin-left: 13rem;

                img {
                  width: 100%;
                  height: 90%;
                }
              }

              .workflow_cont3 {
                font-size: 9rem;
                font-family: Arial-BoldMT, Arial;
                font-weight: bold;
                color: #333333;
                width: 64rem;
                height: 22rem;
                float: left;
                text-align: center;
                margin-top: 2rem;
              }
            }
          }

          .mb-abous {
            width: 100rem;
            margin: 10rem auto;
            background-color: #FFFFFF;
            padding: 2rem;

            .bgtwo_title {
              font-size: 20px;
              font-weight: 900;
              text-align: center;
              margin-bottom: 10px;
            }

            .abous_us {
              p {
                font-size: 13px;
                line-height: 20px;
                color: #888;
              }

              .top-line {
                margin-top: 4rem;

                .line {
                  border: 2px red solid;
                  width: 8rem;
                }

                .abous_title {
                  font-size: 15px;
                  font-weight: bold;
                  color: black;
                }
              }
            }
          }

          .join_us {
            width: 100%;
            height: 25rem;
            background-color: #F98E20;
            margin-top: 10rem;
            border-top-left-radius: 9rem;
            border-top-right-radius: 7rem;

            .join_title {
              float: left;
              width: 10rem;
              height: 10rem;
              margin-top: 8rem;
              margin-left: 28rem;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .join_content {
              font-size: 10rem;
              font-family: Arial-BoldMT, Arial;
              font-weight: bold;
              color: #FFFFFF;
              float: left;
              margin-top: 8rem;
              margin-left: 5rem;
            }
          }
        }
      }
    }
  }
}
</style>